import React from "react";
import styles from "./ReturnsPolicy.module.scss";
import logoBlackSquare from "../assets/footer/cork-square-logo.png";
import { Link } from "react-router-dom";

export default function ReturnsPolicy() {
  const currentYear = new Date().getFullYear();

  return (
    <div className={styles.ReturnsPolicy}>
      <div className={styles.grid}>
        <div className={styles.logoContainer}>
          <Link to="/">
            <img src={logoBlackSquare} />
          </Link>
        </div>
        <div className={styles.mainColumn}>
          <h1>Returns Policy</h1>

          <p>
            We have a 30-day return policy, which means you have 30 days after
            receiving your item to request a return. To be eligible for a
            return, your item must be in the same condition that you received
            it, unworn or unused, with tags, and in its original packaging.
            You'll also need the receipt or proof of purchase. To start a
            return, you can contact us at{" "}
            <a href="mailto:corkmatters.online@gmail.com">
              corkmatters.online@gmail.com
            </a>
            . Please note that returns will need to be sent to the following
            address: R. do Rosário 143 145, 4050-519 Porto. Items sent back to
            us without first requesting a return will not be accepted. You can
            always contact us for any return question at{" "}
            <a href="mailto:corkmatters.online@gmail.com">
              corkmatters.online@gmail.com
            </a>
            .
          </p>

          <h2>Return Shipping Costs</h2>
          <p>
            For change-of-mind or unwanted returns, the cost of return shipping
            is the responsibility of the customer. We recommend using a tracked
            shipping service, as we cannot be held responsible for items lost in
            transit. For returns due to a manufacturing defect or an error on
            our part, we will cover all return shipping costs.
          </p>

          <h2>Damages and Issues</h2>
          <p>
            Please inspect your order upon reception and contact us immediately
            if the item is defective, damaged or if you receive the wrong item,
            so that we can evaluate the issue and make it right.
          </p>
          <p>
            In accordance with EU consumer law, all products are covered by a
            2-year legal guarantee from the date of delivery. This guarantee
            applies exclusively to manufacturing defects — faults that existed
            at the time of production, such as structural failures, material
            defects, or items that do not conform to their description. It does
            not cover damage caused by normal wear and tear, misuse, accidents,
            or modifications made after delivery. If you believe your item has a
            manufacturing defect, please contact us at{" "}
            <a href="mailto:corkmatters.online@gmail.com">
              corkmatters.online@gmail.com
            </a>{" "}
            with a description and photos of the issue. We will assess the claim
            and, where applicable, offer a repair, replacement, or refund at no
            cost to you.
          </p>

          <h2>Exceptions / Non-Returnable Items</h2>
          <p>
            Certain types of items cannot be returned, like perishable goods
            (such as food, flowers, or plants), custom products (such as special
            orders or personalized items), and personal care goods (such as
            beauty products). We also do not accept returns for hazardous
            materials, flammable liquids, or gases. Please get in touch if you
            have questions or concerns about your specific item. Unfortunately,
            we cannot accept returns on sale items or gift cards.
          </p>

          <h2>Exchanges</h2>
          <p>
            The fastest way to ensure you get what you want is to return the
            item you have, and once the return is accepted, make a separate
            purchase for the new item.
          </p>

          <h2>European Union 14 Day Cooling Off Period</h2>
          <p>
            Notwithstanding the above, if the merchandise is being shipped into
            the European Union, you have the right to cancel or return your
            order within 14 days, for any reason and without a justification.
            As above, your item must be in the same condition that you received
            it, unworn or unused, with tags, and in its original packaging.
            You'll also need the receipt or proof of purchase. Please note that
            the cost of return shipping under the cooling-off period is the
            responsibility of the customer.
          </p>

          <h2>Refunds</h2>
          <p>
            We will notify you once we've received and inspected your return,
            and let you know if the refund was approved or not. If approved,
            you'll be automatically refunded on your original payment method
            within 10 business days. Please remember it can take some time for
            your bank or credit card company to process and post the refund too.
            If more than 15 business days have passed since we've approved your
            return, please contact us at{" "}
            <a href="mailto:corkmatters.online@gmail.com">
              corkmatters.online@gmail.com
            </a>
            .
          </p>

          <p>Last updated: March 18, 2026</p>
        </div>
      </div>
    </div>
  );
}